export default __webpack_public_path__ + "static/purple-636425b8d43d51dea4218c5293576a85.gif";